import { useMediaPredicate } from "react-media-hook"

import appTheme from "../appTheme"

export const useIsMobileMOrHigher = () =>
  useMediaPredicate(`(min-width: ${appTheme.breakpoints.mobileM / 16}em)`)

export const useIsMobileOrHigher = () =>
  useMediaPredicate(`(min-width: ${appTheme.breakpoints.mobile / 16}em)`)

export const useIsTabletOrHigher = () =>
  useMediaPredicate(`(min-width: ${appTheme.breakpoints.tablet / 16}em)`)

export const useIsHamburgerLargeOrHigher = () =>
  useMediaPredicate(`(min-width: ${appTheme.breakpoints.hamburgerLarge / 16}em)`)

export const useIsDesktopLOrHigher = () =>
  useMediaPredicate(`(min-width: ${appTheme.breakpoints.desktopL / 16}em)`)
